import { useState } from "react";
import { environment } from "../../config/environment";
import { useAuthStore } from "../../stores/authStore";
import { debugJWT, testTokenInAPI } from "../../utils/debug";

/**
 * Painel de diagnóstico da sessão, visível apenas em desenvolvimento.
 * Lê o mesmo store que o resto da aplicação: se algo aparecer errado aqui,
 * está errado para todo mundo.
 */
export const AuthDebugger = () => {
  const [showDebug, setShowDebug] = useState(false);
  const user = useAuthStore((state) => state.user);
  const token = useAuthStore((state) => state.token);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isTokenExpired = useAuthStore((state) => state.isTokenExpired);
  const clearAuth = useAuthStore((state) => state.clearAuth);

  const testApiCall = async () => {
    if (!token) {
      console.log("Nenhum token na sessão");
      return;
    }
    debugJWT(token);
    await testTokenInAPI(token);
  };

  const debugAuth = () => {
    console.log("Sessão:", {
      isAuthenticated,
      expirado: isTokenExpired(),
      usuario: user?.nome,
      cliente: user?.nomeCliente,
      expiresAt: user?.expiresAt,
      temToken: !!token,
      persistido: !!localStorage.getItem("auth-storage"),
    });
    if (token) debugJWT(token);
  };

  if (!environment.isDevelopment) {
    return null;
  }

  const caixa = {
    position: "fixed" as const,
    bottom: "10px",
    right: "10px",
    backgroundColor: "#333",
    color: "white",
    borderRadius: "4px",
    fontSize: "12px",
    zIndex: 9999,
  };

  if (!showDebug) {
    return (
      <div
        style={{ ...caixa, padding: "8px 12px", cursor: "pointer" }}
        onClick={() => setShowDebug(true)}
      >
        🔍 Auth Debug
      </div>
    );
  }

  return (
    <div style={{ ...caixa, padding: "12px", maxWidth: "320px", lineHeight: 1.6 }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: "12px" }}>
        <strong>Sessão</strong>
        <span style={{ cursor: "pointer" }} onClick={() => setShowDebug(false)}>
          ✕
        </span>
      </div>

      <div>autenticado: {isAuthenticated ? "sim" : "não"}</div>
      <div>expirado: {isTokenExpired() ? "sim" : "não"}</div>
      <div>usuário: {user?.nome ?? "—"}</div>
      <div>cliente: {user?.nomeCliente ?? "—"}</div>
      <div>expira em: {user?.expiresAt ?? "—"}</div>
      <div>token: {token ? "presente" : "ausente"}</div>
      <div>auth-storage: {localStorage.getItem("auth-storage") ? "✅" : "❌"}</div>

      <hr style={{ borderColor: "#555", margin: "8px 0" }} />
      <div>ambiente: {environment.name}</div>
      <div style={{ wordBreak: "break-all" }}>api: {environment.apiBaseUrl}</div>

      <div style={{ display: "flex", gap: "8px", marginTop: "10px", flexWrap: "wrap" }}>
        <button onClick={debugAuth}>Estado</button>
        <button onClick={testApiCall}>Testar token</button>
        <button onClick={clearAuth}>Encerrar sessão</button>
      </div>
    </div>
  );
};
